import { render } from "./newsEdit.vue?vue&type=template&id=666b85b8&scoped=true"
import script from "./newsEdit.vue?vue&type=script&lang=js"
export * from "./newsEdit.vue?vue&type=script&lang=js"

import "./newsEdit.vue?vue&type=style&index=0&id=666b85b8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b85b8"],['__file',"src/views/website/components/newsEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "666b85b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('666b85b8', __exports__)) {
    console.log('reload')
    api.reload('666b85b8', __exports__)
  }
  
  module.hot.accept("./newsEdit.vue?vue&type=template&id=666b85b8&scoped=true", () => {
    console.log('re-render')
    api.rerender('666b85b8', render)
  })

}


export default __exports__